<template>
  <Card :title="$t('emailchangeconfirmation.general.title')">
    <template v-slot:content>
      <p>
        {{ $t('emailchangeconfirmation.general.descriptionConfirmation') }}
      </p>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton
          v-if="processOrigin !== undefined && processOrigin !== null"
          @click="backToOriginProcess"
          buttonId="email-change.zurueck-zu-process-button"
          :buttonColor="ButtonColor.PRIMARY"
        >
          {{ $t('emailchangeconfirmation.returnTo.' + processOrigin.process) }}
        </CustomButton>
        <CustomButton
          @click="backToSettings"
          buttonId="email-change.zurueck-zu-einstellungen-button"
          :buttonColor="ButtonColor.LINK"
        >
          {{ $t('emailchangeconfirmation.returnTo.text') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import { usePoliciesStore } from '@/stores/policiesStore'
import { navigateBackFromEmailChange } from '@/components/account-management/emailchange/EmailChangeNavigation'

const policiesStore = usePoliciesStore()

const processOrigin = policiesStore.getProcessReturnContext() ?? null

const backToSettings = (): void => {
  policiesStore.resetProcessReturnContext()
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.PERSONAL_PROFIL_PAGE)
}

const backToOriginProcess = (): void => {
  navigateBackFromEmailChange(policiesStore)
}
</script>
